// src/pages/Login/index.tsx
import React, { useState } from "react";
import Alert from "components/Alert";
import { Label, Title } from "components/Text";
import { Button } from "components/Button/Button.styled";
import { Layout } from "components/Layout/Layout.styled";
import { getAuthorization } from "helpers/Login";
import { IAlertProps } from "components/Alert/Alert.interface";
import { useDispatch } from "react-redux";
import { nanoid } from "nanoid";
import { AUTH_TYPES } from "store/actions/types";
import { Card } from "react-bootstrap";
import ct from 'assets/clavetributaria.png';
import cu from 'assets/claveunica.svg';

const Login = () => {
  const [alert, setAlert] = useState<IAlertProps>({
    show: false,
    message: null,
    title: null,
    type: null,
  });

  const dispatch = useDispatch();

  const handleAuthorization = async () => {
    try {
      const uuid = nanoid();
      dispatch({
        type: AUTH_TYPES.GENERATE_TOKEN,
        payload: {
          uuid,
        },
      });
      await getAuthorization(uuid);
    } catch (error) {
      console.error(error);
      setAlert({
        show: true,
        message:
          "Error al intentar obtener autorización de clave única. Intente nuevamente.",
        type: "danger",
        title: "Ups! Ha ocurrido un error.",
      });
      setTimeout(() => {
        setAlert({
          ...alert,
          show: false,
        });
      }, 3000);
    }
  };

  return (
    <Layout title="login">
      <div className="container d-flex flex-column" style={{ height: "60vh" }}>
        <div className="row flex-grow-1">
          <div className="col-md-12 d-flex flex-column justify-content-center align-items-center">
            <Alert
              type={alert.type}
              title={alert.title}
              message={alert.message}
              show={alert.show}
            />
            <div className="col justify-content-center align-content-center">
              <Title className="text-center">Registro Consultores</Title>

              <Card className="card-login">
                <Card.Body>
                  <Card.Title className="text-center">
                    Iniciar Sesión
                  </Card.Title>
                  <Card.Text className="text-center">
                    Seleccione el método de autenticación
                  </Card.Text>
                  <div className="col">
                    <div className="d-flex flex-column align-items-center justify-content-center">
                      <Label>Clave Única</Label>
                      <Button
                        className="btn-cu my-3"
                        id="login-clave-unica"
                        title="Clave Única"
                        onClick={() => {
                          handleAuthorization();
                        }}
                      >
                        <img src={cu} alt="CU" height={'40rem'}/>
                      </Button>
                      <br />
                      <Label>Clave Tributaria</Label>
                      <Button
                        className="btn btn-ct my-3"
                        id="login-clave-tributaria"
                        title="Clave Tributaria"
                        onClick={() => {
                          setAlert({
                            show: true,
                            message:
                              "Atención! Está funcionalidad aún está en construcción.",
                            title: "Ups!",
                            type: "info",
                          });
                          setTimeout(() => {
                            setAlert({
                              show: false,
                              message: null,
                              title: null,
                              type: null,
                            });
                          }, 3000);
                        }}
                      >
                        <div className="d-flex align-items-center justify-content-center">
                          <img src={ct} alt="CT" height={'40rem'}/>                          
                        </div>
                      </Button>
                    </div>
                  </div>
                </Card.Body>
              </Card>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default Login;
